import React from 'react'
import PieChart from './PieChart'
import seqStore from '../../store/seqStore'
import Mute from '../inputs/Mute'
import Solo from '../inputs/Solo'
import DisplayNote from '../sequencer/DisplayNote'

export default function TracksMonitor() {

    const playhead = seqStore((state) => state.settings.playhead)
    const length = seqStore((state) => state.settings.length)
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const setCurrentTrack = seqStore((state) => state.setCurrentTrack)

    const handleCurrentTrack = (track) => {
        setCurrentTrack(track)
    }

    return (
        <div id='tracksWrapper'>
            <div className={currentTrack === 0? 'currentTrackWrapper' : 'trackWrapper'} onClick={() => handleCurrentTrack(0)}>
                <PieChart playhead={playhead[0]} length={length[0]} color={'var(--clr_yellow)'} border={'var(--clr_yellow_light)'}/>
                <div className='soloMuteWrapper'>
                    <Solo track={0}/>
                    <Mute track={0}/>
                </div>
                <DisplayNote track={0} colour={'var(--clr_yellow)'}/>
            </div>
            <div className={currentTrack === 1? 'currentTrackWrapper' : 'trackWrapper'} onClick={() => handleCurrentTrack(1)}>
                <PieChart playhead={playhead[1]} length={length[1]} color={'var(--clr_red)'} border={'var(--clr_red_light)'}/>
                <div className='soloMuteWrapper'>
                    <Solo track={1}/>
                    <Mute track={1}/>
                </div>
                <DisplayNote track={1} colour={'var(--clr_red)'}/>
            </div>
            <div className={currentTrack === 2? 'currentTrackWrapper' : 'trackWrapper'} onClick={() => handleCurrentTrack(2)}>
                <PieChart playhead={playhead[2]} length={length[2]} color={'var(--clr_green)'} border={'var(--clr_green_light)'}/>
                <div className='soloMuteWrapper'>
                    <Solo track={2}/>
                    <Mute track={2}/>
                </div>
                <DisplayNote track={2} colour={'var(--clr_green)'}/>
            </div>
            <div className={currentTrack === 3? 'currentTrackWrapper' : 'trackWrapper'} onClick={() => handleCurrentTrack(3)}>
                <PieChart playhead={playhead[3]} length={length[3]} color={'var(--clr_blue)'} border={'var(--clr_blue_light)'}/>
                <div className='soloMuteWrapper'>
                    <Solo track={3}/>
                    <Mute track={3}/>
                </div>
                <DisplayNote track={3} colour={'var(--clr_blue)'}/>
            </div>
        </div>
    )
}
